<template>
  <el-container>
    <el-main style="padding: 0; display: flex">
      <div v-if="flag" style="width: 500px">
        <span>生产过程扫描</span>
        <el-divider/>
        <div class="scanContent">
          <div class="left">
            <el-form
                ref="form"
                style="width: 400px"
                :model="model"
                class="form"
                label-width="80px">
              <el-form-item label="工单编号">
                <el-input
                    v-model="model.billNo"
                    placeholder="请输入工单编号"
                    style="width:400px"
                    @keyup.enter.native="getWorkCenterData"/>
              </el-form-item>
              <el-form-item label="工作中心">
                <el-input v-model="model.workCenterName" placeholder="请选择工作中心" style="width:400px" readonly>
                  <el-button slot="append" @click="$refs.workCenterSelect.open()"> 选择</el-button>
                </el-input>
                <work-center-select ref="workCenterSelect" @select="workCenterSelect"/>
              </el-form-item>
              <el-form-item label="工艺路线">
                <el-input v-model="model.routingName" placeholder="请选择工艺路线" style="width:400px" readonly>
                  <el-button
                      slot="append"
                      :disabled="!model.workCenterName"
                      @click="$refs.rtRouteSelect.open(model.workCenterId)">
                    选择
                  </el-button>
                </el-input>
                <rt-route-select ref="rtRouteSelect" @select="rtRouteSelect"/>
              </el-form-item>
              <el-form-item label="工序">
                <el-input v-model="model.productionProcessName" style="width:400px" placeholder="请选择工序" readonly>
                  <el-button
                      slot="append"
                      :disabled="!model.routingName"
                      @click="$refs.procedureSelect.open(model.routeId)">
                    选择
                  </el-button>
                </el-input>
                <procedure-select ref="procedureSelect" @select="onProcedureSelect"/>
              </el-form-item>
              <el-form-item label="操作员工">
                <el-input
                    ref="empNoInput"
                    v-model="employeeNo"
                    placeholder="请扫描员工条码"
                    style="width:400px"
                    size="mini"
                    @keyup.enter.native="empNoInput"/>
              </el-form-item>
              <el-form-item label="操作员工名">
                <el-input
                    v-model="model.employeeName"
                    disabled
                    style="width:400px"
                    size="mini"/>
              </el-form-item>
              <el-form-item label="产品序列号">
                <el-input
                    ref="snInput"
                    v-model="model.sn"
                    style="width: 400px;float:left"
                    placeholder="请扫描产品序列号"
                    size="mini"
                    @keyup.enter.native="snInput"/>
                <el-checkbox v-model="model.startScan" style="float: left;">开工</el-checkbox>
                <!--                <el-button style="margin-left: 20px;float: left" type="primary" round plain @click="startWork">确定</el-button>-->
              </el-form-item>
            </el-form>
            <div style="margin-top: 20px">部件扫描</div>
            <el-divider/>
            <el-table border :data="partsData" style="width: 100%">
              <el-table-column prop="partsSn" width="150" align="center" label="部件条码">
                <template slot-scope="scope">
                  <el-input
                      :ref="'Input_' + scope.$index"
                      v-model="scope.row.partsSn"
                      placeholder="请扫描部件条码"
                      @keyup.enter.native="scanPartsn(scope.$index)"/>
                </template>
              </el-table-column>
              <el-table-column prop="partsNo" width="150" align="left" label="部件编号"/>
              <el-table-column prop="partsName" align="left" label="部件名称"/>
            </el-table>
            <el-button
                v-if="model.materialNo!==''"
                type="primary"
                style="margin-top: 20px"
                @click="$refs.materialBom.open(model.materialNo)">
              查看BOM
            </el-button>
            <material-bom ref="materialBom"/>
          </div>
        </div>
      </div>
      <div v-if="model.esopId" style="margin-left: 10px; flex: 1">
        <div class="right">
          <!--          <pdf-preview :pdf-url="model.esopFile" :page-num="+model.esopPageNo" @isFullScreen="isFullScreen"/>-->
          <div style="float: left;">
            <el-button type="primary" @click="isFullScreen()">全屏</el-button>
          </div>
          <pdf-preview ref="pdfRead" :pdf-url="model.url"/>
        </div>
<!--        <el-button-->
<!--            type="primary"-->
<!--            style="margin-top: 10px;float:right"-->
<!--            @click="$refs.fileUpload.open(model.esopId)">-->
<!--          Esop修改-->
<!--        </el-button>-->
<!--        <file-upload ref="fileUpload"/>-->
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import workCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import RtRouteSelect from "@/views/information/RtRoute/RtRouteSelect";
  import ProcedureSelect from "@/views/information/Procedure/ProcedureSelect.vue";
  // import PdfPreview from "@/components/PdfPreview";
  import MaterialBom from "@/views/ProductionManagement/ProductionScan/MaterialBom";
  import FileUpload from "@/views/ProductionManagement/ProductionScan/EsopChangeRecord";
  import PdfPreview from "@/components/PdfPreview1";

  export default {
    name: "ProductionScanIndex",
    components: {
      FileUpload,
      MaterialBom,
      workCenterSelect,
      RtRouteSelect,
      ProcedureSelect,
      PdfPreview,
    },

    data() {
      return {
        partsData: [],
        flag: true,
        employeeNo: "",
        model: {
          workCenterName: "",
          billNo: "",
          materialNo: "",
          employeeNo: "",
          employeeName: "",
          workCenterId: "",
          productionProcessId: "",
          productionProcessName: "",
          sn: "",
          routingName: "",
          routeId: "",
          esopPageNo: "",
          esopFile: "",
          startScan: false,
          url: "",
        },
      };
    },

    methods: {
      getWorkCenterData() {
        // this.model.url = "";
        this.$http.get("basic", `taskDispatchBills/getRouteByNo?billNo=${this.model.billNo}`).then((resp) => {
          if (resp.success) {
            let workCenter = resp.data.workCenter;
            let route = resp.data.route;
            this.model.workCenterName = workCenter.workCenterName;
            this.model.materialNo = resp.data.materialNo;
            this.model.workCenterId = workCenter.pkId;
            this.model.routingName = route.routingName;
            this.model.routeId = route.pkid;
            // this.model.esopFile = resp.data.esopFile;
            this.model.esopId = resp.data.esopId;
            this.model.esopName = resp.data.esopName;
            this.model.esopPageNo = resp.data.esopPageNo;
            if (resp.data.esopId) {
              // this.getFileInfoByEsopId(resp.data.esopId);
              this.loadPdf(resp.data.esopFile);
            }
          }
        });
      },
      //加载pdf
      loadPdf(url) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(url)}`).then((res) => {
          if (res.success) {
            this.model.url = res.data;
          }
        }).catch(() => {
        });
      },

      // 选择工作中心
      workCenterSelect(row) {
        this.model.workCenterName = row.workCenterName;
        this.model.workCenterId = row.pkId;
        this.model.routingName = "";
        this.model.routeId = "";
        this.model.productionProcessId = "";
        this.model.productionProcessName = "";
        this.model.sn = "";
      },
      isFullScreen() {
        this.flag = !this.flag;
      },
      // 根据工作中心选择工艺路线
      rtRouteSelect(row) {
        this.model.routingName = row.routingName;
        this.model.routeId = row.pkid;
        this.model.productionProcessId = "";
        this.model.productionProcessName = "";
        this.model.sn = "";
      },

      // 选择工序
      onProcedureSelect(row) {
        this.model.productionProcessId = row.pkid;
        this.model.productionProcessName = row.processName;
        this.model.esopPageNo = row.esopPageNo ? row.esopPageNo : 1;
        this.model.sn = "";
        // if(row.esopId) {
        //   this.getFileInfoByEsopId(row.esopId);
        // }
      },
      empNoInput() {
        if (this.model.employeeNo.includes(this.employeeNo)) {
          return this.$message.error("重复扫描！");
        }
        this.$http.get("basic", "employees/selectByNo/" + this.employeeNo).then((resp) => {
          if (resp.success) {
            // this.$refs.snInput.focus();
            console.log(resp.data);
            if (this.model.employeeNo === "" || this.model.employeeName === "") {
              this.model.employeeNo = resp.data.employeeNO;
              this.model.employeeName = resp.data.employeeName;
            } else {
              this.model.employeeNo = this.model.employeeNo + "," + resp.data.employeeNO;
              this.model.employeeName = this.model.employeeName + "," + resp.data.employeeName;
            }
            this.employeeNo = "";
          } else {
            this.employeeNo = "";
            this.$refs.empNoInput.focus();
          }
        });
      },
      getFileInfoByEsopId(esopId) {
        this.$http.get("basic", `esops/${esopId}`).then((resp) => {
          if (resp.success) {
            this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(resp.data.filePath)}`).then((res) => {
              if (res.success) {
                this.model.esopFile = res.data;
              }
            });
          }
        });
      },
      startWork() {

      },
      snInput() {
        if (!this.model.workCenterId) {
          this.$confirm("请选择工作中心", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.model.sn = "";
          return;
        }
        if (!this.model.routeId) {
          this.$confirm("请选择工艺路线", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.model.sn = "";
          return;
        }
        if (!this.model.productionProcessId) {
          this.$confirm("请选择工序", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.model.sn = "";
          return;
        }
        if (this.model.sn) {
          let params = {
            materialSn: this.model.sn,
            workCenterId: this.model.workCenterId,
            routeId: this.model.routeId,
            processId: this.model.productionProcessId,
            employeeNo: this.model.employeeNo,
            startScan: this.model.startScan,
          };
          this.$http.post("basic", "productionScan/scanMain", params).then((resp) => {
            if (resp.success) {
              console.log(resp);
              this.partsData = resp.data.items;
              if (resp.data.items == null) {
                this.$message.success("工序开工");
                this.model.sn = "";
              } else if (!resp.data.items.length) {
                this.$message.success("该工序已完工");
                this.model.sn = "";
              } else {
                this.$nextTick(() => {
                  this.$refs["Input_0"].focus();
                });
              }
            } else {
              this.model.sn = "";
            }
          });
        }
      },

      // 扫描部件条码
      scanPartsn(index) {
        const arr = this.partsData.filter((item) => !item.partsSn);
        if (!arr.length) {
          const params = {
            productionLineId: this.model.productionLineId,
            processId: this.model.productionProcessId,
            materialSn: this.model.sn,
            partsScan: this.partsData,
          };
          this.$http.post("basic", "productionScan/scanParts", params).then((resp) => {
            if (resp.success) {
              this.$message.success(resp.message);
              this.partsData = [];
            }
            this.model.sn = "";
          });
        }
        if (index === this.partsData.length - 1) {
          this.$refs.snInput.focus();
        } else {
          this.$refs["Input_" + (index + 1)].focus();
        }
      },
    },
  };
</script>

<style scoped>
.el-divider--horizontal {
  margin: 10px 0 10px 0;
}
</style>
